module.exports = __webpack_public_path__ + "static/img/ourAppBtn1.72f5209e.png";